baseApp.directive('trackPopup', function() {
    return {
        templateUrl: '/public/directives/track.html',
        controller: ["$scope", "$state", "$timeout", "$element", function($scope, $state, $timeout, $element) {
            $scope.newMailDef = {};

            $element = $($element);


            store.fetch({
                method: 'POST',
                path: '/users',
                queryParams: {
                    accountId: $state.params.accountId,
                },
                success: function (data) {
                    $scope.admins = data.items;
                },
            });


            $scope.mailingListFocus = function(){
                $element.find('.mailingListName').focus();
            };

            $scope.showAddMailingList = function(){
                $scope.showAddList = !$scope.showAddList;

                $timeout(function(){
                    $scope.$root.updateScroll();
                }, 1, false);
            };

            $scope.cancelAddMailingList = function(){
                $element.find('.mailingListName').removeClass('has-error');
                $scope.listNameError = false;
                $scope.showAddList = false;
            };

            $scope.saveMailingList = function(){
                var $nameField =  $element.find('.mailingListName');
                $scope.listNameError = false;
                $nameField.removeClass('has-error');

                if(!$scope.newMailDef.name || $scope.newMailDef.name === ""){
                    $scope.listNameError = 'List name is required';
                    $nameField.addClass('has-error');
                    return;
                }

                var newMailingList = {
                    name: $scope.newMailDef.name,
                    type: "REGULAR",
                    items: []
                };

                if($scope.newMailDef.freeText){
                    var mails = $scope.newMailDef.freeText.split(",");
                    mails.forEach(function(mail){
                        if(mail) {
                            newMailingList.items.push({"address":mail});
                        }
                    });
                }

                if($scope.newMailDef.selectedItems){
                    $scope.newMailDef.selectedItems.forEach(function(admin){
                        newMailingList.items.push({id: admin});
                    });
                }


                store.fetch({
                    path: '/getAccountMailingDefinition?accountId=' + $state.params.accountId,
                    success: function(data) {
                        $scope.mailingDefinition = data;
                        $scope.mailingDefinition.mails.push(newMailingList);

                          store.save({
                            path: '/saveMailingLists',
                            queryParams: {
                                accountId: $state.params.accountId
                            },
                            data: $scope.mailingDefinition,
                            dataObj: 'mailingLists',
                            success: function(data){
                                $scope.$root.handleServerResponse(data, 'mailing list', 'Mailing list saved successfully');
                                $scope.mailingLists = [];
                                data.mails.forEach(function(list) {
                                    $scope.mailingLists.push(list.name);
                                });

                                if (data.status !== 'ERROR') {
                                    $scope.scopeSelection.addresses = $scope.newMailDef.name;
                                    $scope.newMailDef = {};
                                    $scope.showAddList = false;
                                }
                            }
                        });
                    }
                });
            };

            $scope.showSelectAdmins = function(){
                $scope.selectAdmins = true;

                $timeout(function(){
                    $scope.$root.updateScroll();
                }, 1, false);
            };

            $scope.isAdminSelected = function(admin){
                if(!$scope.newMailDef.selectedItems){
                    return false;
                }

                return $scope.newMailDef.selectedItems.indexOf(admin.id) >= 0;
            };

            $scope.toggleAdmin = function(admin){
                if(!$scope.newMailDef.selectedItems){
                    $scope.newMailDef.selectedItems = [];
                }

                var itemPos = $scope.newMailDef.selectedItems.indexOf(admin.id);
                if(itemPos >= 0){
                    $scope.newMailDef.selectedItems.splice(itemPos, 1);
                }
                else {
                    $scope.newMailDef.selectedItems.push(admin.id);
                }
            };
        }]
    }
});